// extracted by mini-css-extract-plugin
module.exports = {"coachComment":"coachComment_coachComment__3FKuD","kansou":"coachComment_kansou__3sg1W","muraiIcon":"coachComment_muraiIcon__31wc1","murai-speak":"coachComment_murai-speak__1bIY7"};